import React, { useEffect, useRef, useState } from 'react';
import { withRouter } from "react-router-dom";

import * as S from './styles';

import { H1, BodyG, BodyGSpan, BodyP } from '../../styles/stylesTypography';
import { theme } from '../../styles/theme';

import LogoBlack from '../../assets/logo-agroreceita-black.svg'
import Celebration from '../../assets/undraw_celebration.svg'
import maintainUtm from '../../services/maintainUtm';
import InputV2 from '../../components/input/input_v2';

export const compendioG = "@compendioG";

const Apresentacao = ({ history }) => {
    const [emailUser, setEmailUser] = useState(" ");
    const user = JSON.parse(localStorage.getItem('@userinfo'));
    const company = user.username;
    const myArray = company.split(" ")

    const gtmData = JSON.parse(localStorage.getItem('gtm_data'))

    useEffect(() => {
        const tour = localStorage.getItem('startTour');
        localStorage.setItem('@open', 'true');
        
        if (tour === 'true') {
            localStorage.setItem('startTour', 'reload-needed');
            
            window.location.reload();
        }
    }, []);

    useEffect(() => {
        const getPLan = localStorage.getItem('@plan_name');
        
        if (getPLan !== "TESTE GRÁTIS") {
            history.push(`/${maintainUtm()}`);
        }
    }, []);
    
    const handleStart = () => {
        localStorage.setItem('startTour', 'reload-needed');
        history.push(`/${maintainUtm()}`);
    };
    
    useEffect(() => {
        setEmailUser(`${myArray.join('')}`);
    }, [myArray]); 

    useEffect(() => {
       const reload = localStorage.getItem('startTour');

        if (reload === 'reload-needed') {
            localStorage.setItem('startTour', 'false');

            window.location.reload();
        }
    }, []);

    useEffect(() => {
        const alreadyChecked = sessionStorage.getItem('checkedLogged');
        
        if (!alreadyChecked && localStorage.getItem('@logged') === 'false') {
          sessionStorage.setItem('checkedLogged', 'true');
          window.location.reload();
        }
      }, []);

    return (
        <S.Container>
            <S.Wrapper>
                <img src={LogoBlack} alt="" className="logo" />

                <S.Content className="content">
                    <img src={Celebration} alt="" />

                    <H1 style={{ fontSize: "2.3rem", textAlign: 'center' }}>Bem-vindo(a) ao AgroReceita!</H1>

                    <S.Description>
                        <BodyG>Aproveite todas as funções do <BodyGSpan>AgroReceita PRO</BodyGSpan> e melhore sua tomada de decisões no campo. </BodyG>
                        <BodyP color={theme.colors.red.Vermelho_erro}>Nada será enviado às Defesas Agropecuárias durante o período de teste grátis. Explore tudo sem medo.</BodyP>
                    </S.Description>

                    <S.Button className="button" onClick={handleStart} >Começar</S.Button>

                    <span id="email">{emailUser}</span>

                    <form style={{display: 'none'}} id='form-cadastro'>
                        <InputV2
                            id="nome"
                            value={gtmData?.nome}
                            label="Nome"
                            marginBottom='0px'
                        />

                        <InputV2
                            id="email"
                            value={gtmData?.email}
                            label="E-mail"
                            marginBottom='0px'
                        />

                        <InputV2
                            id="telefonecelular"
                            value={gtmData?.telefone}
                            label="Telefone/celular"
                            marginBottom='0px'
                        />
                    </form>   
                </S.Content>
            </S.Wrapper>
        </S.Container>
    );
};

export default withRouter(Apresentacao);
